import React, { useState, useEffect } from 'react';
import Group from '../../images/cartoon-four.jpg'
import { Link } from 'react-router-dom'
import { getToken } from '../../utils/tokenHelper';
import Star from '../../images/star.png'


const Hero = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        // Check if the token exists in localStorage
        const token = getToken();
        if (token) {
            setIsLoggedIn(true);
        }
    }, []);

    return (
        <div className='w-full p-4 md:px-8 lg:px-16 raleway-font'>
            <div className='w-full flex flex-col gap-4 lg:flex-row items-center justify-center'>
                <div className='w-full flex flex-col gap-2 items-center'>

                    <p className='text-2xl text-center  leading-[1.4] instrument-sans-bold tracking-wider text-[#262323] md:text-4xl xl:text-5xl'>
                        Play, Learn, Earn:
                    </p>
                    <p className='text-2xl text-center leading-[1.4] instrument-sans-bold tracking-wider text-[#069125] md:text-4xl xl:text-5xl '>
                        Health Quizzes
                    </p>

                    <p className='text-sm text-center instrument-sans-medium text-[#233126] tracking-wider mt-1   lg:mt-3'>
                        Get quality medical insights on any health related issue from anywhere in the world; 
                        <br className='hidden lg:block'/> earn rewards by playing health quizzes. 
                    </p>

                    <div className="flex gap-4 mt-4 instrument-sans-semibold">
                        {isLoggedIn ? (
                            <Link to='/trivia-games'
                            className='bg-gradient-to-b from-[#069125] to-[#6AEF88] flex items-center text-white font-medium px-4 py-2 rounded-lg gap-2 text-xs  md:text-base'
                            >
                                <img src={Star} alt="" className='w-[11.5px] h-[8.5px] md:w-[23px] md:h-[17px]'/>
                                <span>Play to Win Now </span>
                            </Link>
                        ) : (
                            <Link to='/login'
                             className='bg-gradient-to-b from-[#069125] to-[#6AEF88] flex items-center text-white font-medium px-4 py-2 rounded-lg gap-2 text-xs  md:text-base' >
                                <img src={Star} alt="" className='w-[11.5px] h-[8.5px] md:w-[23px] md:h-[17px]'/>
                                <span>Play to Win Now </span>
                            </Link>
                        )}

                        {isLoggedIn ? (
                            <Link to='/health' className='border bg-white shadow-lg border-[#069125] text-[#069125] font-medium px-3 py-2 rounded-lg hover:bg-gray-100/70 text-xs  md:text-base
                            '>
                                Ask AI Doctor
                            </Link>
                        ) : (
                            <Link to='/login' className='border bg-white shadow-lg border-[#069125] text-[#069125] font-medium px-3 py-2 rounded-lg hover:bg-gray-100/70 text-xs  md:text-base
                            '>
                                Ask AI Doctor
                            </Link>
                        )}
                    </div>
                </div>
            </div>

           
        </div>
    )
}

export default Hero